import { ADD_NOTIFICATION_TO_STORE, MARK_NOTIFICATION_AS_READ } from "./types";

export const addNotificationsToStoreAction = (model) => async (dispatch) => {
  dispatch({ type: ADD_NOTIFICATION_TO_STORE, payload: model });
};

export const markNotificationAsReadAction = (model) => async (dispatch) => {
  dispatch({ type: MARK_NOTIFICATION_AS_READ, payload: model });
};
